import styled from 'styled-components'

export const FunFactsHeader = styled.h4`
  border-bottom: 1px solid #dfcea1;
  padding-bottom: 5px;
  margin-top: 30px;
`;